import styled from '@emotion/styled'
import {
    breakpoint,
    breakpointSwitch,
    calcRem,
    getComponentTheme,
} from '../../__styling'
import { StyledMediaProps } from '../Landscape/Landscape.styled'
import { ImageRatio } from '@news-mono/web-common'
import { CardMedia } from '../CardMedia/CardMedia'

export const StyledLandscapeNumber = styled('div')(({ theme }) => {
    const iconTheme = getComponentTheme(theme, 'landscape').number
    return [
        {
            //fontSize: calcRem(40),
            color: iconTheme.color,
            fontWeight: 400,
            paddingRight: calcRem(16),
            //lineHeight: calcRem(40),
        },
        breakpointSwitch(
            iconTheme.breakpointState,
            ({ fontSize, lineHeight }) => ({
                fontSize,
                lineHeight,
            }),
        ),
    ]
})

export interface StyledNightlyMediaProps extends StyledMediaProps {
    CSSCrop: ImageRatio
    numbered: boolean
}

export const StyledNightlyMedia = styled(CardMedia)<StyledNightlyMediaProps>(
    ({ imagePosition, theme, imageWidths, CSSCrop, numbered }) => ({
        width: imageWidths.mobile,
        height: getImageHeight(CSSCrop, imageWidths.mobile),
        margin:
            imagePosition === 'right'
                ? `0 0 0 ${calcRem(theme.margins.sm)}`
                : `0 ${calcRem(theme.margins.sm)} 0 0`,

        [breakpoint('sm')]: {
            width: imageWidths.tablet,
            height: getImageHeight(CSSCrop, imageWidths.tablet),
        },
        [breakpoint('lg')]: {
            width: imageWidths.desktop,
            height: getImageHeight(CSSCrop, imageWidths.desktop),
            display: numbered ? 'none' : undefined,
        },
    }),
)

function getImageHeight(ratio: ImageRatio, width: string) {
    return (parseInt(width, 10) / ratio.width) * ratio.height
}
